import { isValid, startOfDay } from 'date-fns';
import { z } from 'zod';

import { toDate, type DateInput } from '@/lib/dates';

/** Valeurs du formulaire « Ma période hivernale ». */
export interface HivernageValues {
    dateFin: DateInput;
}

/** Contrôle de l'activation de Ma période hivernale (ancien `Hivernage/validate.js`). */
export const hivernageSchema = z.looseObject({}).superRefine((values, ctx) => {
    const v = values as Partial<HivernageValues>;
    const errors: Record<string, string> = {};

    if (!v.dateFin) {
        errors.dateFin = 'Le champ est obligatoire';
    }

    if (v.dateFin) {
        const dateFin = toDate(v.dateFin);
        /* moment(x).isSameOrBefore(début du jour) : faux pour une date invalide. */
        if (isValid(dateFin) && dateFin.getTime() <= startOfDay(new Date()).getTime()) {
            errors.dateFin = "La durée de Ma période hivernale doit être d'au moins une journée";
        }
    }

    for (const [path, message] of Object.entries(errors)) ctx.addIssue({ code: 'custom', path: [path], message });
});
